import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import PropTypes from "prop-types";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import AgendaList from "./AgendaList";

const useStyles = makeStyles({
	root: {
		flexGrow: 1
	}
});

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<Typography
			component="div"
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			<Box p={3}>{children}</Box>
		</Typography>
	);
}

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`
	};
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired
};

export default function CenteredTabs() {
	const classes = useStyles();
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const [meetingStatus, setMeetingStatus] = React.useState(0);

	const handleMeetingStatus = () => {
		setMeetingStatus(!meetingStatus);
	};

	return (
		<Paper className={classes.root}>
			<Tabs
				value={value}
				onChange={handleChange}
				indicatorColor="primary"
				textColor="primary"
			>
				<Tab label="Meeting Details" {...a11yProps(0)} />
				<Tab label="Agenda" {...a11yProps(1)} />
				<Tab label="Actions" {...a11yProps(2)} />
				<Tab label="Announcement" {...a11yProps(3)} />
				<Tab label="Settings" {...a11yProps(4)} />
			</Tabs>
			<TabPanel value={value} index={0}>
				<p>Test Meeting Details</p>
			</TabPanel>
			<TabPanel value={value} index={1}>
				<AgendaList />
			</TabPanel>
			<TabPanel value={value} index={2}>
				<p>
					{/* action Lorem ipsum dolor sit, amet consectetur adipisicing elit.
					Ducimus, praesentium! */}
				</p>
			</TabPanel>
			<TabPanel value={value} index={3}>
				<p>
					{/* announcement Lorem ipsum dolor sit amet consectetur adipisicing elit.
					Voluptates, quia? */}
				</p>
			</TabPanel>
			<TabPanel value={value} index={4}>
				{meetingStatus == 0 ? (
					<Button
						variant="contained"
						color="primary"
						className={classes.button}
						onClick={handleMeetingStatus}
					>
						Start Meeting
					</Button>
				) : (
					<Button
						variant="contained"
						color="secondary"
						className={classes.button}
						onClick={handleMeetingStatus}
					>
						End Meeting
					</Button>
				)}
			</TabPanel>
		</Paper>
	);
}
